// Buttons
import button from "art/button.png";
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { StyledButton } from "components/Button/v2";
import { StyledInput, StyledNumberInput } from "./TextInput/v2";

const Label = styled.div`
  color: white;
  font-size: 8vw;
  margin-bottom: 1vw;
`;

const Wrapper = styled.div`
  margin: 2vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2vw;
`;

const IncrementButton = styled(StyledButton)`
  font-size: 5vw;
  width: 8vw;
  height: 8vw;
  padding: 0;
  margin: 0;
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1vw;
`;

const NumberInput = ({
  label,
  isLong,
  value,
  onChange,
  upperCased,
  type,
  min,
  max,
  disabled,
  dataTestId,
  ...rest
}) => {
  const [_value, setValue] = useState(value ?? "");

  // Update internal state when value prop changes
  useEffect(() => {
    setValue(value ?? "");
  }, [value]);

  const _onChange = (e) => {
    let value = e?.target?.value;
    if (upperCased) {
      value = value?.toUpperCase();
    }
    onChange(value);
    setValue(value);
  };

  const handleIncrement = () => {
    const numValue = parseInt(_value) || 0;
    const newValue =
      max !== undefined ? Math.min(numValue + 1, max) : numValue + 1;
    onChange(newValue.toString());
    setValue(newValue.toString());
  };

  const handleDecrement = () => {
    const numValue = parseInt(_value) || 0;
    const newValue =
      min !== undefined ? Math.max(numValue - 1, min) : numValue - 1;
    onChange(newValue.toString());
    setValue(newValue.toString());
  };

  const numValue = parseInt(_value) || 0;
  const isAtMax = max !== undefined && numValue >= max;
  const isAtMin = min !== undefined && numValue <= min;
  const showIncrementButtons = type === "number";

  return (
    <Wrapper>
      <Label htmlFor={label}>{label}</Label>
      <InputContainer>
        {showIncrementButtons && (
          <IncrementButton
            onClick={handleDecrement}
            disabled={disabled || isAtMin}
            type="button"
          >
            −
          </IncrementButton>
        )}
        <StyledNumberInput
          {...rest}
          id={label}
          value={_value}
          onChange={_onChange}
          type={type}
          disabled={disabled}
          heightOverride={1.5}
          widthOverride={1}
          data-test-id={dataTestId}
        />
        {showIncrementButtons && (
          <IncrementButton
            onClick={handleIncrement}
            disabled={disabled || isAtMax}
            type="button"
          >   
            +
          </IncrementButton>
        )}
      </InputContainer>
    </Wrapper>
  );
};

export default NumberInput;
